import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "D:/personal/githubrepo/rx-form-state/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props } from 'docz';
import FieldApi from './FieldApi';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "field"
    }}>{`Field`}</h1>
    <p>{`表单域组件。`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { Field } from '@sinoui/rx-form-state';
`}</code></pre>
    <h2 {...{
      "id": "属性"
    }}>{`属性`}</h2>
    <p>{`Field 组件固定的属性有：`}</p>
    <Props of={FieldApi} mdxType="Props" />
    <p>{`除了这些固定的属性，还可以指定它包含的表单域组件的属性，如`}<inlineCode parentName="p">{`as="input"`}</inlineCode>{`，则可以将 input 相关的属性定义在 Field 组件之上，传递给`}<inlineCode parentName="p">{`input`}</inlineCode>{`：`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<Field as="input" name="userName" placeholder="请输入用户名" />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      